import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47fe8305"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-column p-align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-mb-4" }, " Reset password ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!
  const _component_GvInputText = _resolveComponent("GvInputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "top-center" }),
    _createVNode(_component_GvSpinner, { "is-loading": _ctx.isLoading }, null, 8 /* PROPS */, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"])),
        class: "forgot-password-form p-d-flex p-flex-column p-align-center"
      }, [
        _createVNode(_component_GvInputText, {
          "data-testid": "email-input",
          "field-name": "Indirizzo email",
          id: "email",
          errors: _ctx.v$.$silentErrors,
          modelValue: _ctx.v$.emailAddress.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.emailAddress.$model) = $event)),
          "is-dirty": _ctx.v$.emailAddress.$dirty,
          style: {"width":"100%"}
        }, null, 8 /* PROPS */, ["errors", "modelValue", "is-dirty"]),
        _createVNode(_component_Button, {
          "data-testid": "reset-password-button p-text-center",
          type: "submit",
          label: "Reset password",
          class: "gv-button reset-button p-mt-4",
          disabled: _ctx.v$.$invalid || _ctx.isLoading
        }, null, 8 /* PROPS */, ["disabled"])
      ], 32 /* HYDRATE_EVENTS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}